import React, { useContext } from 'react';

import { EditIcon } from '@vlabs/icons';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { TableContext } from '@vlabs/uikit/components/table/table-context';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function EditCell({
  row = undefined,
  buttonProps = undefined,
}) {
  const { t } = useTranslation();
  const { actions, onActions } = useContext(TableContext);
  const onEdit = actions.onEditRow?.getHandlerIfCan?.(row.original);
  if (!onEdit) return null;

  const permissions = onActions?.onEditRow?.permissions;
  const label = actions.onEditRow?.label;

  return (
    <ButtonWithPermissions
      data-testid="editCell"
      icon={<EditIcon />}
      kind="primary"
      onClick={() => onEdit(row.original)}
      permissions={permissions}
      title={label || t('uikit:table.actions.edit')}
      variant="dimmed"
      {...(buttonProps || {})}
    />
  );
}

EditCell.propTypes = ({
  row: PropTypes.objectOf(PropTypes.any),
  buttonProps: PropTypes.object,
});

export { EditCell };
